__turbopack_context__.v({
  "description": "ExperienceTimeline-module__3WInFG__description",
  "item": "ExperienceTimeline-module__3WInFG__item",
  "marker": "ExperienceTimeline-module__3WInFG__marker",
  "org": "ExperienceTimeline-module__3WInFG__org",
  "period": "ExperienceTimeline-module__3WInFG__period",
  "role": "ExperienceTimeline-module__3WInFG__role",
  "timeline": "ExperienceTimeline-module__3WInFG__timeline",
});
